module.exports = __webpack_public_path__ + "img/1.31e98335.png";